// extracted by mini-css-extract-plugin
export var deleteModal = "_g8-0";